import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fla",
  "use": "icon-fla-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fla\"><path fill=\"#333333\" d=\"M296.96 153.6v305.152h257.024v76.8H296.96v411.648H181.248v-870.4H583.68v78.848H296.96V153.6z m433.152 793.6V81.92h111.616v865.28H730.112z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol